import React, { lazy } from 'react';
import Loadable from 'components/loading/Loadable';
import { StaffBoardApi } from 'api/community/StaffBoardApi';
import { StaffProvider } from './context';

const List = Loadable(lazy(() => import('./list')));
const Create = Loadable(lazy(() => import('./create')));
const Edit = Loadable(lazy(() => import('./edit')));

const StaffBoardConfig = {
    routes: [
        {
            path: 'staff',
            children: [
                {
                    path: '',
                    element: <StaffProvider><List /></StaffProvider>
                },
                {
                    path: 'create',
                    element: <StaffProvider><Create /></StaffProvider>
                },
                {
                    path: 'modify/:code',
                    element: <StaffProvider><Edit /></StaffProvider>
                }
            ]
        }
    ],
    API: StaffBoardApi
};

export default StaffBoardConfig;
